<router-outlet></router-outlet>
<!-- Floating Chat Icon -->
<!-- <div class="chat-icon-container" (click)="openChat()">
    <div class="chat-bubble">
        <i class="bi bi-chat-dots-fill"></i>
    </div>
    <span class="chat-tooltip">Chat with us</span>
</div> -->